import React, { Component } from "react";

const BathroomIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5596 10.6641H15.7706V3.39844C15.7706 1.52451 14.2461 0 12.3721 0C10.5376 0 9.03793 1.46133 8.97598 3.28125H7.68463V4.45312H11.4346V3.28125H10.1488C10.21 2.10785 11.1838 1.17188 12.3721 1.17188C13.5999 1.17188 14.5987 2.17072 14.5987 3.39844V10.6641H0.46875V11.8359H1.47369V14.3079C1.47369 16.1436 2.63306 17.7135 4.25781 18.3244V20H5.42969V18.5844C5.5397 18.593 5.65094 18.5974 5.76309 18.5974H14.2653C14.3774 18.5974 14.4887 18.593 14.5987 18.5844V20H15.7706V18.3244C17.3953 17.7135 18.5547 16.1436 18.5547 14.3079V11.8359H19.5596V10.6641ZM17.3828 14.3079C17.3828 16.0269 15.9842 17.4254 14.2653 17.4254H5.76324C4.04419 17.4254 2.64557 16.0269 2.64557 14.3079V11.8359H4.84497V14.7527H11.0168V11.8359H17.3828V14.3079ZM9.84497 11.8359V13.5808H6.01685V11.8359H9.84497Z"
        fill={fill}
      />
    </svg>
  );
};

BathroomIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: "black",
};

export default BathroomIcon;
